__turbopack_context__.v({
  "action": "bXoc0W_action",
  "actions": "bXoc0W_actions",
  "bbSheetFade": "bXoc0W_bbSheetFade",
  "bbSheetRise": "bXoc0W_bbSheetRise",
  "bbSheetUp": "bXoc0W_bbSheetUp",
  "body": "bXoc0W_body",
  "content": "bXoc0W_content",
  "dialog": "bXoc0W_dialog",
  "item": "bXoc0W_item",
  "items": "bXoc0W_items",
  "more": "bXoc0W_more",
  "overlay": "bXoc0W_overlay",
  "primary": "bXoc0W_primary",
  "secondary": "bXoc0W_secondary",
  "text": "bXoc0W_text",
  "title": "bXoc0W_title",
});
